<template>
    <div class="row position-relative" style="margin-top: 55px;">
        <div class="bg-computer">
            <div class="row container my-5 py-3">
                <div class="col-2"></div>
                <div class="col-md-5 text-end pe-5">
                    <h3 class="fw-bold my-4">دستیار هوشمند ارزدیجیتال</h3>
                    <h5 class="fw-bold my-4">خدمات متنوع و تخصصی بازار ارزهای دیجیتال</h5>
                    <h6 class="my-4">با استفاده از بروز ترین خدمات حداکثر بازدهی را تجربه کنید</h6>
                    <button class="btn-blue">ثبت نام رایگان</button>
                </div>
                <div class="col-md-5 text-start">
                    <img src="../../assets/services-img/computer.png" width="85%" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row col-md-9 mx-auto">
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <div class="col-lg-7 text-end">
                        <h2 class="fw-bold">خدمات جامع و هوشمند ترید💯</h2>
                        <h5 class="mt-3 ps-3" style="line-height: 30px;">
                            یکی از پیچیده ترین کارها را شاید بتوان ترید کردن ذکر کرد. ما در بایتیکل همواره خدماتی را ارایه و توسعه دادیه ایم که بتوان از انها برای افزایش بازدهی ترید استفاده کرد همچنین باتوجه به گسترده بودن و ۲۴ ساعته بودن بازار ارزهای دیجیتال هر تریدر نیازمند یک دستیاری میباشد که شبانه روز در جستجوی موقعیت های مناسب معاملاتی باشد .</h5>
                        <button class="btn-blue mt-4">ثبت نام رایگان</button>
                    </div>
                    <div class="col-lg-5 my-auto text-start">
                        <img src="../../assets/test/blog1.webp" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-lg-5 my-auto text-end">
                        <img src="../../assets/test/blog1.webp" class="w-100" alt="">
                    </div>
                    <div class="col-lg-7 text-end">
                        <h2 class="fw-bold">خدمات جامع و هوشمند ترید💯</h2>
                        <h5 class="mt-3 ps-3" style="line-height: 30px;">
                            یکی از پیچیده ترین کارها را شاید بتوان ترید کردن ذکر کرد. ما در بایتیکل همواره خدماتی را ارایه و توسعه دادیه ایم که بتوان از انها برای افزایش بازدهی ترید استفاده کرد همچنین باتوجه به گسترده بودن و ۲۴ ساعته بودن بازار ارزهای دیجیتال هر تریدر نیازمند یک دستیاری میباشد که شبانه روز در جستجوی موقعیت های مناسب معاملاتی باشد .</h5>
                        <button class="btn-blue mt-4">ثبت نام رایگان</button>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-lg-7 text-end">
                        <h2 class="fw-bold">خدمات جامع و هوشمند ترید💯</h2>
                        <h5 class="mt-3 ps-3" style="line-height: 30px;">
                            یکی از پیچیده ترین کارها را شاید بتوان ترید کردن ذکر کرد. ما در بایتیکل همواره خدماتی را ارایه و توسعه دادیه ایم که بتوان از انها برای افزایش بازدهی ترید استفاده کرد همچنین باتوجه به گسترده بودن و ۲۴ ساعته بودن بازار ارزهای دیجیتال هر تریدر نیازمند یک دستیاری میباشد که شبانه روز در جستجوی موقعیت های مناسب معاملاتی باشد .</h5>
                        <button class="btn-blue mt-4">ثبت نام رایگان</button>
                    </div>
                    <div class="col-lg-5 my-auto text-start">
                        <img src="../../assets/test/blog1.webp" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-lg-5 my-auto text-end">
                        <img src="../../assets/test/blog1.webp" class="w-100" alt="">
                    </div>
                    <div class="col-lg-7 text-end">
                        <h2 class="fw-bold">خدمات جامع و هوشمند ترید💯</h2>
                        <h5 class="mt-3 ps-3" style="line-height: 30px;">
                            یکی از پیچیده ترین کارها را شاید بتوان ترید کردن ذکر کرد. ما در بایتیکل همواره خدماتی را ارایه و توسعه دادیه ایم که بتوان از انها برای افزایش بازدهی ترید استفاده کرد همچنین باتوجه به گسترده بودن و ۲۴ ساعته بودن بازار ارزهای دیجیتال هر تریدر نیازمند یک دستیاری میباشد که شبانه روز در جستجوی موقعیت های مناسب معاملاتی باشد .</h5>
                        <button class="btn-blue mt-4">ثبت نام رایگان</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row position-relative">
        <div class="bg-computer" style="border-top-right-radius: 40px;">
            <div class="row container my-5 py-3 text-end">
                <h3 class="fw-bold">خرید اشتراک برای دسترسی به امکانات پیشرفته بایتیکل</h3>
                <h6>همین الان بایتیکل رو امتحان کن و در صورت نیاز، اشتراکت رو ارتقا بده.</h6>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>